import React from 'react'
import { Link } from 'react-router-dom'
import { LABELS } from '../constants/staticText'
import RichText from '../../lib/components/RichText'
import useLoad from '../functions/useLoad'
import { overviewTrail } from '../functions/eventTrail'
import EventBreadcrumb from './EventBreadcrumb'
import { loadEvents } from '../apis/publicApi'
import EventCard from './EventCard'
import { useDocumentTitle } from '../../lib/a11y/useDocumentTitle'
import LoadingIndicator from '../../lib/components/LoadingIndicator'
import { useFocusHeading } from '../../lib/a11y/useFocusHeading'

// Die Einleitung ist die Hauptueberschrift der Uebersicht (Audit 2026-10-07,
// S3): das Theme druckte „Events" als h1 — unsichtbar und auf jeder Seite der
// App gleich; seit PublicPages.php es unterdrueckt, traegt jede Seite ihre h1
// selbst. Ueberschrift und Einleitung pflegt die Redaktion per ACF an der
// WordPress-Seite "events" (#237).
const IntroSidebar = ({ overview, headingRef }) => (
    <aside className="events-intro">
        <h1 tabIndex={-1} ref={headingRef}>{overview.title}</h1>
        <RichText html={overview.intro} />
    </aside>
)

// Reihenfolge der Abschnitte; ihre Ueberschriften kommen mit den Texten.
const SECTION_ORDER = ['upcoming', 'permanent', 'future']

const EventsOverview = () => {
    const { data, loading, error } = useLoad(loadEvents, [])
    const overview = window.matrixPublicParams.overview
    useDocumentTitle(LABELS.overviewTitle)
    // Fokus auf die h1 nach dem Laden (#178, #236), ohne zu scrollen.
    const headingRef = useFocusHeading(!loading && !error, { preventScroll: true })

    // Lade- und Fehlerzustand als Status, damit ein Screenreader sie hoert (#178).
    if (loading) return <LoadingIndicator label={LABELS.loadingEvents} />
    if (error) return <p className="events-state" role="status">{LABELS.error}</p>

    return (
        <>
            {/* Wie auf den Unterseiten ueber dem Zweispalter, nicht darin:
                die Leiste geht ueber die ganze Breite (#82). */}
            <EventBreadcrumb trail={overviewTrail()} />
            <div className="events-overview">
                <IntroSidebar overview={overview} headingRef={headingRef} />
                <div className="events-sections">
                    {SECTION_ORDER.map(status => {
                        const events = (data || []).filter(event => event.status === status)
                        // Ein Abschnitt ohne Messe bliebe eine leere Ueberschrift.
                        if (events.length === 0) return null
                        return (
                            <section key={status} className={`events-section events-section-${status}`}>
                                <h2 className="events-section-title">{overview.sectionTitles[status]}</h2>
                                <ul className="events-cards">
                                    {events.map(event => <EventCard key={event.slug} event={event} LinkComponent={Link} />)}
                                </ul>
                            </section>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default EventsOverview
